<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div class="alert alert-danger" v-if="!loading && message?.text">
      <p><span v-html="message.text"/> <strong v-if="message.date">{{ printDate(message.date, 'DD.MM.YYYY') }}</strong>
      </p>
    </div>
  </div>
</template>
<script>

import moment from "moment";

export default {
  props: ['cityId', 'deliveryDate'],
  data() {
    return {
      loading: true,
      message: {},
    }
  },
  computed: {
    $StoreSendSchedule() {
      return this.$store.getters['platform/storeSendSchedule'];
    },
  },
  created() {
    this.updateDeliveryPoint();
  },
  watch: {
    $StoreSendSchedule() {
      this.updateDeliveryPoint();
    },
    cityId() {
      this.updateDeliveryPoint();
    },
    deliveryDate() {
      this.updateDeliveryPoint();
    }
  },
  methods: {
    updateDeliveryPoint() {
      if (!this.$StoreSendSchedule) return;
      this.message = {};
      const div = Object.values(this.$AllDivisions).find((d) => d.is_active && d.cities.find((c) => c.object_id === this.cityId));
      const receiveStore = div?.stores?.[0]?.store?.id ?? 0;
      const sendStore = div?.stores?.[0]?.store?.parent_id ?? 0;
      const sendDuration = this.$StoreSendSchedule?.[sendStore]?.allowedToSend?.[receiveStore] ?? null;
      let sendSchedule = this.$StoreSendSchedule?.[sendStore]?.sendSchedule?.[receiveStore] ?? null;
      let freeDays = this.$StoreSendSchedule?.extraRecords?.workingTime?.find((w) => w.object_id === div?.id)?.data?.free_days ?? [];
      // console.log(div);
      // console.log(sendStore, receiveStore);
      // console.log(sendDuration, sendSchedule, freeDays);
      if (!sendDuration?.active || !(sendSchedule ?? []).length) {
        this.message = {text: 'Склад не имеет регулярной отправки'};
        this.loading = false;
        return;
      }

      const todayDayNum = moment().isoWeekday();
      let closesDeliveryDate = null;

      sendSchedule = sendSchedule.map((d) => d.dayOfWeek).sort((a, b) => a - b);

      sendSchedule.forEach((d) => {
        if (closesDeliveryDate) return;
        if (d > todayDayNum) {
          closesDeliveryDate = d - todayDayNum;
        }
      })
      if (!closesDeliveryDate) {
        closesDeliveryDate = (7 - todayDayNum) + sendSchedule[0];
      }
      closesDeliveryDate = moment().set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }).add(closesDeliveryDate + +sendDuration.days, 'days');
      //add day after receiving
      // closesDeliveryDate.add(1, 'days');
      // console.log(closesDeliveryDate, +closesDeliveryDate.isoWeekday());

      const allFreeDays = freeDays.sort((a, b) => a.day_num - b.day_num);
      closesDeliveryDate = this.getClosedDeliveryDate(allFreeDays, closesDeliveryDate);
      const deliveryDate = moment(this.deliveryDate, 'YYYY-MM-DD').set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      });

      // console.log('-----', closesDeliveryDate, deliveryDate);
      // console.log(deliveryDate.diff(closesDeliveryDate, 'days'));
      const dayDiff = deliveryDate.diff(closesDeliveryDate, 'days');

      if (dayDiff < 0) {
        this.message = {
          text: 'С учетом доставки препарата и графика работы курьера, ориентировочный <strong>день получения посылки / начало доставок</strong>',
          date: closesDeliveryDate
        };
      }
      if (dayDiff > 0) {
        closesDeliveryDate = this.getClosedDeliveryDate(allFreeDays, moment(deliveryDate.toISOString()));
        // console.log('res', closesDeliveryDate, deliveryDate.diff(closesDeliveryDate, 'days'));
        if (deliveryDate.diff(closesDeliveryDate, 'days') !== 0) {
          this.message = {
            text: 'С учетом доставки препарата и графика работы курьера, ориентировочный <strong>день получения посылки / начало доставок</strong>',
            date: closesDeliveryDate
          };
        }
      }
      this.loading = false;
    },
    getClosedDeliveryDate(allFreeDays, closesDeliveryDate) {
      let findWorkingDays = false;
      let count = 0;
      let dayShifted = false;
      while (!findWorkingDays && count < 30) {
        dayShifted = false;
        allFreeDays.forEach((d) => {
          if ((+d.city_id === +this.cityId || !+d.city_id)
            && +closesDeliveryDate.isoWeekday() === +d.day_num) {
            // console.log('ketch free day', d, closesDeliveryDate);
            closesDeliveryDate = closesDeliveryDate.add(1, 'days');
            // console.log(closesDeliveryDate);
            dayShifted = true;
          }
        })
        ++count;
        if (!dayShifted) findWorkingDays = true;
      }
      return closesDeliveryDate;
    }
  }
}

</script>
